// extracted by mini-css-extract-plugin
export default {"sectionHeader":"Faq_sectionHeader__W7jkk","paper":"Faq_paper__iaA4d"};